import { IMessage } from "Interfaces/IMessage";

export class Message implements IMessage {
    public type: string = "";
    public text: string = "";
}


// WEBPACK FOOTER //
// ./src/Models/Message.ts